import { getTranslation } from '../utils/i18n';
import { isMastercard } from '../utils/cardScheme';
import './StandardCardLayout.css';

export default function StandardCardLayout({
  children,
  title,
  subtitle,
  errorMessage,
  mode,
  scheme = 'visa'
}) {
  const activeMode = mode || localStorage.getItem('session_mode') || ((typeof process !== 'undefined' && process.env.REACT_APP_MODE) || undefined) || 'standardEN';
  const t = getTranslation(activeMode);
  const isRtl = t.dir === 'rtl';

  const isMc = scheme === 'mastercard' || scheme === 'mc' || isMastercard(scheme);
  const schemeImg = isMc ? '/images/manual/master.jpg' : '/images/manual/visa.jpg';
  const schemeAlt = isMc ? 'Mastercard' : 'Visa';

  // Details
  const merchant = localStorage.getItem('session_merchant') || ((typeof process !== 'undefined' && process.env.REACT_APP_MERCHANT_NAME) || undefined) || 'Merchant';
  const amount = localStorage.getItem('session_amount') || localStorage.getItem('summ') || '';
  const currency = localStorage.getItem('session_currency') || localStorage.getItem('currency') || ((typeof process !== 'undefined' && process.env.REACT_APP_CURRENCY) || undefined) || 'USD';
  const last4 = localStorage.getItem('session_last4') || localStorage.getItem('last-four-digits') || '';
  const rawEmail = localStorage.getItem('session_email') || '';
  const email = (rawEmail && rawEmail !== 'undefined' && rawEmail !== 'null') ? rawEmail.trim() : '';

  const today = new Date();
  const formattedDate = `${today.getDate().toString().padStart(2, '0')}/${(today.getMonth() + 1).toString().padStart(2, '0')}/${today.getFullYear()}`;

  return (
    <div className={`scl-wrapper ${isRtl ? 'scl-wrapper--rtl' : ''}`} dir={t.dir}>
      <div className="scl-card">
        {/* Header: PCI DSS on left, Scheme on right */}
        <div className="scl-header">
          <img 
            src="/images/manual/pci.jpg" 
            alt="PCI DSS Compliant" 
            className="scl-pci-logo" 
            onError={(e) => { e.target.style.display = 'none'; }}
          />
          {schemeImg && (
            <img 
              src={schemeImg} 
              alt={schemeAlt} 
              className="scl-scheme-logo" 
              onError={(e) => { e.target.style.display = 'none'; }}
            />
          )}
        </div>

        {/* Title & Description */}
        {title && <h1 className="scl-title">{title}</h1>}
        {subtitle && <p className="scl-desc">{subtitle}</p>}

        {/* Error message banner */}
        {errorMessage && (
          <div className="scl-error-banner" role="alert">
            <svg className="scl-error-icon" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
            </svg>
            <div className="scl-error-body">
              <div className="scl-error-title">{isRtl ? 'إشعار أمني' : 'Security Notice'}</div>
              <div className="scl-error-text">{errorMessage}</div>
            </div>
          </div>
        )}

        {/* Details Grid */}
        <div className="scl-details-grid">
          <span className="scl-detail-label">{t.merchant}:</span>
          <span className="scl-detail-value">{merchant}</span>

          <span className="scl-detail-label">{isRtl ? 'التاريخ:' : 'Date:'}</span>
          <span className="scl-detail-value--muted" dir="ltr">{formattedDate}</span>

          <span className="scl-detail-label">{t.cardNumber}:</span>
          <span className="scl-detail-value" dir="ltr">**** **** **** {last4 || '••••'}</span>

          <span className="scl-detail-label">{t.amount}:</span>
          <span className="scl-detail-value" dir="ltr">{currency} {amount || '0.00'}</span>

          {email ? (
            <>
              <span className="scl-detail-label">{t.customerEmail}:</span>
              <span className="scl-detail-value" dir="ltr">{email}</span>
            </>
          ) : null}
        </div>

        {/* Dynamic 3DS View Body */}
        <div>
          {children}
        </div>
      </div>
    </div>
  );
}

